// import defaultSettings from '@/settings'
import { isTest } from './fn'

const title = isTest() ? '汇服八方 - 测试' : '汇服八方'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
